<template>
  <div class="cash-withdrawal">

    <div class="my-promotion">
      <div class="header"style="background-color: #ec5d59 !important;">
        <div class="name acea-row row-center-wrapper">
          <div>累计转换</div>
        </div>
        <div class="num">{{change_money || 0}}</div>
        <div class="name acea-row row-center-wrapper">
          <div>{{transfer_name}}余额</div>
        </div>
        <div class="num">{{commissionCount || 0}}</div>
      </div>
    </div>
    <div class="bill-details">
      <div class="nav acea-row">
        <div class="item on"  >
          转换
        </div>
        <div class="item" @click="toCommissionList()" >
          转换记录
        </div>
      </div>
    </div>

    <div class="wrapper" style="background-color:#fff;">
      <div  class="list">

        <div class="item acea-row row-between-wrapper">
          <div class="name">选择账户</div>
          <div class="input">
            <select v-model="post.extract_field" @change='extractType'>
              <option
                      v-for="(text, index) in changeType"
                      :value="index"
                      :key="index"
              >
                {{ text }}
              </option>
            </select>

          </div>
        </div>

        <div class="item acea-row row-between-wrapper">
          <div class="name">转换账户</div>
          <div class="input">
            <select v-model="post.extract_other_field" @change='extractOtherType'>
              <option
                  v-for="(text, index) in changeOtherType"
                  :value="index"
                  :key="index"
              >
                {{ text }}
              </option>
            </select>

          </div>
        </div>
        <div class="tip" style="color:red;">{{other_nickname}}</div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">转换金额</div>
          <div class="input">
            <input :placeholder="placeholder" v-model="post.money" />
          </div>
        </div>
        <div class="item acea-row row-between-wrapper">
          <div class="name">填验证码</div>
          <div class="input"  style="width:2rem;">
            <input placeholder="填写验证码" style="width:2rem;" v-model="post.codeVal" />
          </div>
          <div class="code" @click="again" style="width:2.5rem;"><img :src="codeUrl"  style="width:2.5rem;" /></div>
        </div>
        <div class="bnt bg-color-red" @click="submitted">转换</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getChange, getOtherAccount,postChangeInfo } from "../../../api/user";
import { required } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import {VUE_APP_API_URL} from "@utils/index";

export default {
  name: "change",
  components: {},
  props: {},
  data: function() {
    return {
      post: {
          account: "",
          money: "",
          extract_field:'',
        extract_other_field:'',
        codeVal: "",
      },
        account: "",
        money: "",
      transfer_name:'',
        changeType:[],
      changeOtherType:[],
        user:[],
      other_nickname:'',
      change_money:0,
      commissionCount: 0,
      commissionCountNow:0,
        minPrice:0,
      placeholder:'',
      keyCode: "",
      codeUrl: "",
    };
  },
    mounted: function() {
      if(this.$route.params.types){
        this.post.extract_field = this.$route.params.types;
      }
        this.getChange();
      this.again();
    },
    watch: {
        $route(n) {
            if (n.name == "change") {
              if(this.$route.params.types){
                this.post.extract_field = this.$route.params.types;
              }
              this.getChange();
              this.again();
            }
        }
    },
  methods: {
    toCommissionList(){
      this.$router.push({path:'/user/changecord/'+this.post.extract_field})
    },
    again() {
      this.codeUrl =
          VUE_APP_API_URL +
          "/sms_captcha?"+Date.parse(new Date());
    },
      getChange: function() {
        let that = this;
          getChange().then(
          res => {
            if(that.post.extract_field==''){
              that.post.extract_field = res.data.extract_field;
            }
            that.change_money = res.data.change_money;
            that.commissionCount = res.data.user[that.post.extract_field];
            that.transfer_name = res.data.changeType[that.post.extract_field];
            that.commissionCountNow = res.data.user[res.data.extract_other_field];
            that.minPrice = res.data.minPrice;
            that.changeType = res.data.changeType;
            that.changeOtherType = res.data.changeOtherType;
            that.post.extract_other_field = res.data.extract_other_field;
            that.user = res.data.user;
            that.placeholder = res.data.placeholder;
          },
          function(err) {
            that.$dialog.message(err.msg);
          }
        );
      },
      extractType:function(){
          this.commissionCount =this.user[this.post.extract_field];
          this.transfer_name = this.changeType[this.post.extract_field];
      },
    extractOtherType:function(){

    },
    async submitted() {
      let money = this.post.money,
          extract_field=this.post.extract_field,
          extract_other_field=this.post.extract_other_field,
          codeVal=this.post.codeVal,
        that = this;
      if (parseFloat(money) > parseFloat(that.commissionCount) || parseFloat(that.commissionCount) == 0) return that.$dialog.message("余额不足");
      if (parseFloat(money) < parseFloat(that.minPrice)) return that.$dialog.message("最低转换金额" + that.minPrice);

        try {
            await this.$validator({
                money: [required.message("转换金额")],
              codeVal:[required.message("验证码")],
            }).validate({  money,codeVal });
            let save = {
              extract_other_field: extract_other_field,
                money: money,
                extract_field:extract_field,
              code:codeVal,
            };
            that.save(save);
        } catch (e) {
            return validatorDefaultCatch(e);
        }

    },
    save: function(info) {
      postChangeInfo(info).then(
        res => {
          this.$dialog.message(res.msg);
          this.$router.push({ path: "/user/changecord/"+this.post.extract_field });
        },
        error => {
          this.again();
          this.$dialog.message(error.msg);
        }
      );
    }
  }
};
</script>
